import { createSelector } from 'reselect';

const substate = (state) => state.payment;

export const selectPaymentTransferResultRecords = () =>
    createSelector(substate, (contextState) => contextState.paymentTransferResultRecords);
